import React from 'react'

const IgToolsNeeded = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={343}
    height={176}
    viewBox="0 0 343 176"
    fill="none"
    style={{ zoom: 2, width: '170px' , height:'80px' }}
    {...props}
  >
    <path
      d="M17.8874 81.4121C17.0621 82.0459 16.6494 82.8122 16.6494 83.5638V87.2927C16.6494 88.2065 17.2537 89.1202 18.4622 89.8276C18.7128 90.1076 19.037 90.3877 19.4497 90.6235C20.4371 91.1836 21.7488 91.4784 23.0458 91.4784C24.3428 91.4784 25.6545 91.1983 26.6419 90.6235C27.0988 90.373 27.4378 90.0635 27.6883 89.7539C28.8084 89.0612 29.3833 88.177 29.3833 87.2927V83.5638C29.3833 82.8564 29.0148 82.149 28.3074 81.5447M21.7341 88.5012V137.919L23.0311 140.675L24.328 137.919V88.5012"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path
      d="M29.1606 82.7228C27.9226 81.9269 27.9226 79.5393 27.9226 79.5393C27.9226 74.8525 29.9565 71.0943 29.9565 71.0943C30.0744 70.8585 30.0745 70.5784 30.0745 70.3131V44.58C30.045 44.0789 29.8828 43.5631 29.5439 43.0915V38.9942C29.5439 38.051 28.9101 37.1077 27.6426 36.3855C26.3751 35.6634 24.7097 35.2949 23.0443 35.2949C21.3789 35.2949 19.7134 35.6634 18.446 36.3855C17.1785 37.1077 16.5447 38.051 16.5447 38.9942V43.062C16.191 43.5484 16.0142 44.0642 16.0142 44.58V70.3131C16.0289 70.5636 16.0731 70.8437 16.1468 71.0943C16.1468 71.0943 18.1659 74.8525 18.1659 79.5393C18.1659 79.5393 18.1659 82.0153 16.869 82.767"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.1606 82.7228C27.9226 81.9269 27.9226 79.5393 27.9226 79.5393C27.9226 74.8525 29.9565 71.0943 29.9565 71.0943C30.0744 70.8585 30.0745 70.5784 30.0745 70.3131L30.0449 44.58C30.0449 44.0789 29.8681 43.5631 29.5439 43.0915V38.9942C29.5439 38.051 28.9101 37.1077 27.6426 36.3855C26.3751 35.6634 24.7097 35.2949 23.0443 35.2949C21.3789 35.2949 19.7134 35.6634 18.446 36.3855C17.1785 37.1077 16.5447 38.051 16.5447 38.9942V43.062C16.191 43.5484 16.0142 44.0642 16.0142 44.58V70.3131C16.0289 70.5636 16.0731 70.8437 16.1468 71.0943C16.1468 71.0943 18.1807 74.8525 18.1807 79.5393C18.1807 79.5393 18.1807 82.0301 16.8837 82.767"
      fill="white"
    />
    <path
      d="M21.7339 88.5137V137.931L23.0309 140.687L24.3278 137.931V88.5137"
      fill="white"
    />
    <path
      d="M23.0303 140.659V137.918L23.6493 134.926C23.6493 134.926 24.1061 137.195 24.1061 137.77C24.1061 138.345 23.0303 140.688 23.0303 140.688"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M21.7339 88.5V137.917L23.0309 140.659L24.3278 137.917V88.5"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path
      d="M29.3833 83.5631C29.3833 82.6346 28.7643 81.7061 27.5262 80.9986C26.2882 80.2912 24.6523 79.9375 23.0163 79.9375C21.3804 79.9375 19.7592 80.2912 18.5064 80.9986C17.2684 81.7061 16.6494 82.6346 16.6494 83.5631V87.2919C16.6494 88.2057 17.2537 89.1194 18.4622 89.8268C18.698 90.1069 19.0223 90.387 19.4497 90.6228C20.4371 91.1828 21.7488 91.4776 23.0458 91.4776C24.3428 91.4776 25.6545 91.1976 26.6419 90.6228C27.0988 90.3575 27.4378 90.0627 27.6883 89.7532C28.8084 89.0605 29.3833 88.1762 29.3833 87.2919V83.5631Z"
      fill="white"
    />
    <path
      d="M27.6882 89.7379C26.4502 90.4453 24.8143 90.7991 23.1931 90.7991C21.5719 90.7991 19.7296 90.46 18.4768 89.7526M29.3832 83.5625C29.3832 84.491 28.7641 85.4196 27.5261 86.127C26.2881 86.8345 24.6522 87.1882 23.031 87.1882C21.4098 87.1882 19.7738 86.8345 18.5358 86.127C17.2978 85.4196 16.6641 84.491 16.6641 83.5625"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M30.0605 70.2975C30.0605 71.3144 29.3826 72.3462 27.9972 73.1273C26.6265 73.9084 24.8285 74.2916 23.0304 74.2916C21.2323 74.2916 19.4342 73.9084 18.0636 73.1273C16.6929 72.3462 16.0002 71.3292 16.0002 70.2975M30.0311 44.5645C30.0311 45.5814 29.3531 46.6131 27.9824 47.3942C26.6118 48.1753 24.8137 48.5585 23.0156 48.5585C21.2176 48.5585 19.4195 48.1753 18.0489 47.3942C16.6782 46.6131 15.9855 45.5961 16.0002 44.5645"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M21.2041 48.3224C21.2041 47.5855 20.6882 47.1581 20.6882 47.1581C20.6882 47.1581 19.2733 46.6865 18.7575 46.5096C18.2417 46.3328 17.6816 47.1434 17.6816 47.1434V72.8027C17.6816 72.8027 18.2269 74.5124 18.7575 74.6893C19.2733 74.8661 20.6882 75.3378 20.6882 75.3378C20.6882 75.3378 21.2041 75.3967 21.2041 74.2618V48.3224Z"
      fill="white"
    />
    <path
      d="M21.2041 48.3224C21.2041 47.5855 20.6882 47.1581 20.6882 47.1581C20.6882 47.1581 19.2733 46.6865 18.7575 46.5096C18.2417 46.3328 17.6816 47.1434 17.6816 47.1434V72.8027C17.6816 72.8027 18.2269 74.5124 18.7575 74.6893C19.2733 74.8661 20.6882 75.3378 20.6882 75.3378C20.6882 75.3378 21.2041 75.3967 21.2041 74.2618V48.3224Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M24.8286 48.3224C24.8286 47.5855 25.3444 47.1581 25.3444 47.1581C25.3444 47.1581 26.7593 46.6865 27.2751 46.5096C27.791 46.3328 28.351 47.1434 28.351 47.1434V72.8027C28.351 72.8027 27.8057 74.5124 27.2751 74.6893C26.7593 74.8661 25.3444 75.3378 25.3444 75.3378C25.3444 75.3378 24.8286 75.3967 24.8286 74.2618V48.3224Z"
      fill="white"
    />
    <path
      d="M24.8286 48.3224C24.8286 47.5855 25.3444 47.1581 25.3444 47.1581C25.3444 47.1581 26.7593 46.6865 27.2751 46.5096C27.791 46.3328 28.351 47.1434 28.351 47.1434V72.8027C28.351 72.8027 27.8057 74.5124 27.2751 74.6893C26.7593 74.8661 25.3444 75.3378 25.3444 75.3378C25.3444 75.3378 24.8286 75.3967 24.8286 74.2618V48.3224Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M29.5303 42.9589C29.5303 43.9021 28.8966 44.8601 27.6291 45.5823C26.3617 46.3044 24.6962 46.6729 23.0308 46.6729C21.3654 46.6729 19.6999 46.3044 18.4325 45.5823C17.165 44.8601 16.5312 43.9168 16.5312 42.9589V38.9795C16.5312 38.0362 17.165 37.093 18.4325 36.3708C19.6999 35.6487 21.3654 35.2949 23.0308 35.2949C24.6962 35.2949 26.3617 35.6634 27.6291 36.3708C28.8966 37.093 29.5303 38.0362 29.5303 38.9795V42.9589Z"
      fill="white"
    />
    <path
      d="M29.5303 38.9805C29.5303 39.9237 28.8966 40.8817 27.6291 41.6039C26.3617 42.3261 24.6962 42.6945 23.0308 42.6945C21.3654 42.6945 19.6999 42.3261 18.4325 41.6039C17.165 40.8817 16.5312 39.9385 16.5312 38.9805"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M29.5303 42.959C29.5303 43.9022 28.8966 44.8602 27.6291 45.5824C26.3617 46.3046 24.6962 46.673 23.0308 46.673C21.3654 46.673 19.6999 46.3046 18.4325 45.5824C17.165 44.8602 16.5312 43.917 16.5312 42.959"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M17.8874 81.4121C17.0621 82.0459 16.6494 82.8122 16.6494 83.5638V87.2779C16.6494 88.1917 17.2537 89.1055 18.4622 89.813C18.698 90.093 19.0223 90.373 19.4497 90.6088C20.4371 91.1688 21.7488 91.4636 23.0458 91.4636C24.3428 91.4636 25.6545 91.1836 26.6419 90.6088C27.0988 90.3435 27.4378 90.0487 27.6883 89.7392C28.8084 89.0465 29.3833 88.1622 29.3833 87.2779V83.5638C29.3833 82.8564 29.0148 82.149 28.3074 81.5447"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path
      d="M29.1606 82.7228C27.9226 81.9269 27.9226 79.5393 27.9226 79.5393C27.9226 74.8525 29.9565 71.0943 29.9565 71.0943C30.0744 70.8585 30.0745 70.5784 30.0745 70.3131V44.58C30.045 44.0789 29.8828 43.5631 29.5439 43.0915V38.9942C29.5439 38.051 28.9101 37.1077 27.6426 36.3855C26.3751 35.6634 24.7097 35.2949 23.0443 35.2949C21.3789 35.2949 19.7134 35.6634 18.446 36.3855C17.1785 37.1077 16.5447 38.051 16.5447 38.9942V43.062C16.191 43.5484 16.0142 44.0642 16.0142 44.58V70.3131C16.0289 70.5636 16.0731 70.8437 16.1468 71.0943C16.1468 71.0943 18.1659 74.8525 18.1659 79.5393C18.1659 79.5393 18.1659 82.0153 16.869 82.767"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M67.245 35.3097C65.9186 35.3097 64.8279 35.9287 64.8279 36.6951V44.9043L64.8133 130.519C64.7838 130.755 67.2008 140.644 67.2008 140.644L69.6326 130.519V36.6803C69.6473 35.9139 68.5715 35.2949 67.245 35.2949V35.3097Z"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path
      d="M67.245 35.3105C65.9038 35.3105 64.8279 35.9296 64.8279 36.696V44.9052L64.8133 130.535C64.7838 130.756 67.2156 140.66 67.2156 140.66L69.6621 130.535V36.696C69.6768 35.9296 68.6009 35.3105 67.2598 35.3105"
      fill="white"
    />
    <path
      d="M64.8008 44.9199C64.8008 45.6863 65.8767 46.3053 67.2179 46.3053C68.5591 46.3053 69.6349 45.6863 69.6349 44.9199"
      stroke="#6B7073"
      strokeWidth={0.5}
    />
    <path
      d="M69.6643 36.5195C69.6643 37.2859 68.5884 37.9196 67.2472 37.9196C65.906 37.9196 64.8301 37.3007 64.8301 36.5195M68.1168 136.902C68.0726 137.167 67.6746 137.374 67.203 137.374C66.7314 137.374 66.3629 137.182 66.2892 136.932"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M69.6496 41.1328C69.6496 41.8992 68.5737 42.5182 67.2325 42.5182C65.8914 42.5182 64.8155 41.8992 64.8155 41.1328M69.6496 43.034C69.6496 43.8004 68.5737 44.4342 67.2325 44.4342C65.8914 44.4342 64.8155 43.8152 64.8155 43.034M69.6349 130.55L68.4263 131.759H66.0093L64.8008 130.55M66.0093 131.744V46.1143M68.4263 131.744V46.1143"
      stroke="#6B7073"
      strokeWidth={0.5}
    />
    <path
      d="M69.6643 39.127C69.6643 39.8933 68.5884 40.5124 67.2472 40.5124C65.906 40.5124 64.8301 39.8933 64.8301 39.127"
      stroke="#6B7073"
      strokeWidth={0.5}
    />
    <path
      d="M64.8008 44.9199V130.549C64.7861 130.771 67.1884 140.675 67.1884 140.675L69.6202 130.549V44.9199"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path
      d="M69.6349 44.9208V36.7116C69.6496 35.9452 68.5737 35.3262 67.2473 35.3262C65.9208 35.3262 64.8302 35.9452 64.8302 36.7116L64.8008 44.9208"
      stroke="#6B7073"
      strokeWidth={2}
    />
    <path
      d="M150.334 119.208L118.868 96.393C118.013 95.9067 117.247 95.8772 116.686 96.2162L102.685 104.588C102.14 104.926 101.801 105.619 101.801 106.607V116.747C101.801 118.722 103.171 121.139 104.866 122.111L136.332 140.269C137.128 140.726 137.865 140.785 138.411 140.505L152.397 132.148C153.016 131.853 153.399 131.117 153.399 130.07V124.587C153.399 121.596 151.926 120.623 150.334 119.223V119.208Z"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path
      d="M133.031 84.413L136.436 86.3732C136.819 86.5943 137.158 86.6237 137.394 86.4764L139.664 85.1794C139.855 85.0615 139.973 84.8404 139.973 84.5309V81.6127M114.476 101.406C115.508 100.758 114.845 97.6185 114.845 97.6185C113.695 81.9222 118.573 78.6946 118.573 74.8332C118.573 70.9717 114.388 66.0933 112 64.7227L141.565 70.3231C138.396 73.8309 137.026 89.2471 136.775 91.4284C136.525 93.6097 136.068 99.9914 133.901 102.718C132.516 105.224 132.486 108.333 136.996 115.614"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M182.035 88.0966C181.784 88.1261 181.593 87.9344 181.593 87.5807C181.593 87.1238 181.902 86.5638 182.3 86.3427C182.58 86.1806 182.831 86.2395 182.949 86.4606M182.035 88.1112L178.321 88.406C177.614 88.3471 177.127 87.7428 177.127 86.7258C177.127 85.2373 178.159 83.4392 179.426 82.7023C180.325 82.1865 181.106 82.3339 181.475 83.0119L182.949 86.4753M182.168 86.4458L196.641 94.8025C196.906 94.9646 197.009 95.3035 196.847 95.5836C196.744 95.7604 196.552 95.8636 196.361 95.8636C196.257 95.8636 196.169 95.8341 196.081 95.7899L181.608 87.4333M112.338 66.5492C104.32 61.9213 101.579 51.6782 106.207 43.6753C110.835 35.6577 121.078 32.9164 129.081 37.5442L153.148 51.4424C153.856 51.8256 154.489 52.3709 155.02 53.0636L162.934 63.3215L174.43 69.9832C174.902 70.2779 175.3 70.6759 175.639 71.177L183.008 80.359C183.524 80.9043 183.818 81.7591 183.818 82.8792C183.818 85.7237 181.858 89.1577 179.441 90.5579C178.601 91.0442 177.82 91.2211 177.142 91.1179L164.85 89.2756C164.511 89.2167 164.187 89.1135 163.892 88.9661L152.367 82.3191L138.955 81.3758C138.292 81.2874 137.673 81.0959 137.113 80.8011L112.338 66.5492Z"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path
      d="M150.377 119.224L118.911 96.4086C118.056 95.9223 117.289 95.8928 116.729 96.2318L102.728 104.603C102.183 104.942 101.844 105.635 101.844 106.622V116.762C101.844 118.737 103.214 121.154 104.909 122.127L136.375 140.299C137.171 140.756 137.908 140.815 138.453 140.535L152.44 132.179C153.059 131.884 153.442 131.147 153.442 130.1V124.603C153.442 121.611 151.968 120.638 150.377 119.238"
      fill="white"
    />
    <path
      d="M102.731 104.603C103.291 104.264 104.057 104.293 104.912 104.78L136.378 127.595C137.955 128.995 139.444 130.041 139.444 132.959V138.442C139.444 139.488 139.061 140.211 138.456 140.52"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M150.363 119.224L118.896 96.4086C118.042 95.9223 117.275 95.8928 116.715 96.2318L102.714 104.603C102.169 104.942 101.83 105.635 101.83 106.608V116.747C101.83 118.722 103.2 121.14 104.895 122.112L136.361 140.27C137.157 140.727 137.894 140.786 138.439 140.506L152.426 132.149C153.045 131.84 153.428 131.117 153.428 130.071V124.588C153.428 121.582 151.954 120.624 150.363 119.224Z"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path
      d="M137.039 115.612C137.378 116.275 137.569 116.865 137.599 117.395C137.776 120.372 132.558 119.532 125.956 115.553C119.353 111.559 113.855 105.914 113.693 102.952C113.649 102.215 113.944 101.699 114.504 101.434"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M114.505 101.42C115.536 100.771 114.873 97.6322 114.873 97.6322C113.724 81.9359 118.602 78.7082 118.602 74.8468C118.602 70.9853 114.416 66.107 112.029 64.7363L141.594 70.3369C138.41 73.8446 137.054 89.2608 136.804 91.4421C136.553 93.6234 136.096 100.005 133.93 102.732C132.544 105.237 132.515 108.347 137.025 115.628"
      fill="white"
    />
    <path
      d="M114.505 101.42C115.536 100.771 114.873 97.6322 114.873 97.6322C113.724 81.9359 118.602 78.7082 118.602 74.8468C118.602 70.9853 114.416 66.107 112.029 64.7363L141.594 70.3369C138.41 73.8446 137.054 89.2608 136.804 91.4421C136.553 93.6234 136.096 100.005 133.93 102.732C132.544 105.237 132.515 108.347 137.025 115.628"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M135.478 85.9297L134.918 86.254C134.476 86.5046 134.019 86.6371 133.576 86.6371C133.208 86.6371 132.854 86.5487 132.545 86.3571C131.896 85.9886 131.528 85.296 131.528 84.4854V77.7942C131.528 77.7942 131.528 77.6616 131.528 77.5879"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M145.692 118.797L135.419 124.722L138.809 127.419L149.082 121.494L145.692 118.797Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M137.171 81.0077L132.956 80.3887L133.044 84.427L136.449 86.3872C136.832 86.6082 137.171 86.6377 137.407 86.5051L139.677 85.2081C139.868 85.0902 139.986 84.8691 139.986 84.5596V81.6267L137.171 81.0077Z"
      fill="white"
    />
    <path
      d="M112.338 66.5491C104.32 61.9213 101.579 51.6782 106.207 43.6753C110.835 35.6577 121.078 32.9164 129.095 37.5442L153.163 51.4424C153.885 51.8256 154.504 52.3709 155.035 53.0636L162.949 63.3215L174.445 69.9832C174.916 70.2779 175.314 70.6759 175.653 71.1917L183.022 80.3736C183.538 80.919 183.833 81.7738 183.833 82.8939C183.833 85.7384 181.873 89.1725 179.456 90.5726C178.616 91.059 177.835 91.2358 177.157 91.1327L164.865 89.2904C164.526 89.2314 164.202 89.1282 163.907 88.9808L152.382 82.3339L138.97 81.3906C138.307 81.3022 137.688 81.1106 137.128 80.8159L112.353 66.5639L112.338 66.5491Z"
      fill="white"
    />
    <path
      d="M118.911 70.293C116.597 69.1139 115.138 66.3431 115.138 62.3342C115.138 54.7145 120.385 45.5179 126.855 41.7743C129.994 39.9615 132.838 39.7699 134.946 40.9195"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M133.295 85.1626C133.516 85.2658 133.811 85.2363 134.136 85.0742"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M137.716 81.2299V85.8725C137.716 86.182 137.598 86.4031 137.406 86.521M113.044 66.9043C110.73 65.7252 109.271 62.9544 109.271 58.9456C109.271 51.3259 114.518 42.1292 120.988 38.3856C124.127 36.5728 126.972 36.3813 129.079 37.5308"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M182.978 86.4902C183.022 86.5787 183.037 86.6671 183.037 86.7998C183.037 87.2567 182.728 87.8167 182.33 88.0377C182.227 88.0967 182.138 88.1262 182.064 88.1262"
      stroke="#6B7073"
      strokeWidth={2}
      strokeMiterlimit={10}
    />
    <path
      d="M133.06 84.4261L136.464 86.3863C136.847 86.6074 137.186 86.6369 137.422 86.5042L139.692 85.2073C139.883 85.0894 140.001 84.883 140.001 84.5588V81.6406"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M132.956 78.5605V84.5001C132.956 84.8391 133.089 85.0601 133.295 85.1633"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M137.143 80.8156C134.829 79.6366 133.37 76.8657 133.37 72.8569C133.37 65.2372 138.617 56.0405 145.087 52.2969C148.226 50.4841 151.07 50.2926 153.178 51.4421M152.485 82.3779C150.894 81.6557 149.891 79.8281 149.891 77.1457C149.891 72.1936 153.296 66.2247 157.511 63.7929C159.663 62.5548 161.593 62.4811 162.979 63.3654M163.907 88.9806C162.36 88.2289 161.387 86.4161 161.387 83.7779C161.387 78.8259 164.792 72.8569 169.007 70.425C171.144 69.187 173.075 69.1134 174.46 69.9829M177.172 91.1324C175.919 90.9556 175.094 89.8059 175.094 87.9489C175.094 85.1044 177.054 81.6704 179.471 80.2702C180.945 79.4154 182.242 79.5186 183.038 80.3734M131.277 77.4257C128.963 76.2467 127.504 73.4759 127.504 69.4671C127.504 61.8474 132.751 52.6507 139.221 48.9072C142.36 47.0943 145.205 46.9027 147.312 48.0523"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M112.368 66.5629C104.365 61.935 101.609 51.6919 106.237 43.689C110.865 35.6714 121.108 32.93 129.111 37.5579L153.179 51.4561C153.886 51.8393 154.52 52.3846 155.036 53.0773L162.95 63.3352L174.446 69.9821C174.917 70.2769 175.315 70.6748 175.654 71.1907L183.023 80.3726C183.539 80.9179 183.834 81.7728 183.834 82.8929C183.834 85.7374 181.874 89.1714 179.457 90.5716C178.617 91.0579 177.836 91.2348 177.158 91.1316L164.866 89.2893C164.527 89.2304 164.203 89.1272 163.908 88.9798L152.383 82.3328L138.971 81.3895C138.308 81.3011 137.689 81.1096 137.129 80.8148L112.354 66.5629H112.368Z"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path
      d="M182.212 86.4746L196.685 94.8312C196.95 94.9933 197.053 95.3323 196.891 95.5976C196.788 95.7745 196.596 95.8777 196.405 95.8777C196.302 95.8777 196.213 95.8482 196.125 95.804L181.667 87.4621"
      fill="white"
    />
    <path
      d="M182.212 86.4746L196.685 94.8312C196.95 94.9933 197.053 95.3323 196.891 95.5976C196.788 95.7745 196.596 95.8777 196.405 95.8777C196.302 95.8777 196.213 95.8482 196.125 95.804L181.667 87.4621"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path
      d="M182.079 88.1273L178.365 88.4221C177.657 88.3631 177.171 87.7589 177.171 86.7419C177.171 85.2533 178.203 83.4553 179.47 82.7184C180.369 82.2025 181.136 82.3499 181.519 83.0132L182.993 86.4766"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path
      d="M182.066 88.1255C181.815 88.1549 181.624 87.9486 181.624 87.6097C181.624 87.1528 181.933 86.5927 182.331 86.3716C182.611 86.2095 182.862 86.2685 182.965 86.4895"
      stroke="#6B7073"
      strokeWidth={2}
      strokeMiterlimit={10}
    />
    <path
      d="M213.4 88.5153L213.591 88.2648C214.741 83.858 214.092 77.5058 214.092 77.5058V73.8507L214.859 72.5684C214.505 71.9789 214.313 71.183 214.313 70.2398C214.313 69.2081 214.549 68.088 214.947 67.0121L214.092 66.4963V59.982L219.973 36.1649L220.636 35.7816L221.299 35.3984L222.611 36.1943L228.492 56.3563V62.8707L227.651 64.3887C228.049 64.993 228.27 65.833 228.27 66.8647C228.27 67.808 228.079 68.8102 227.74 69.7976H227.755L228.492 70.2251V73.8802C228.492 73.8802 227.932 79.9818 228.757 83.3274H228.816L229.567 83.7548C229.567 83.7548 238.366 97.2109 238.366 107.867C238.366 118.522 233.768 125.567 233.768 125.567C233.768 125.567 232.692 128.073 231.66 129.532C231.233 130.136 230.746 130.107 230.29 130.004C230.245 130.004 228.123 128.633 228.123 128.633C227.534 128.323 227.121 127.439 227.43 126.614C227.43 126.614 230.584 118.581 230.584 107.94C230.584 99.7606 225.116 89.9154 222.582 85.8034L222.021 85.3023C221.83 86.0393 221.388 87.4688 221.137 88.1173L221.668 88.4121C221.668 88.4121 212.014 111.861 212.014 122.502C212.014 133.143 215.625 136.606 215.625 136.606C216.141 137.432 214.564 140.836 213.532 140.571C213.4 140.541 213.267 140.483 213.134 140.424L210.319 138.729C209.435 138.301 208.624 137.343 208.624 137.343C208.624 137.343 205.028 133.88 205.028 123.239C205.028 112.598 213.429 88.5005 213.429 88.5005L213.4 88.5153Z"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M213.386 88.5153L213.578 88.2648C214.727 83.858 214.079 77.5058 214.079 77.5058V73.8507L214.845 72.5684C214.491 71.9789 214.3 71.183 214.3 70.2398C214.3 69.1933 214.536 68.088 214.934 67.0121L214.079 66.4963V59.982L219.959 36.1649L220.622 35.7816L221.286 35.3984L222.597 36.1943L228.478 56.3563V62.8706L227.638 64.3887C228.036 64.993 228.257 65.833 228.257 66.8647C228.257 67.808 228.065 68.8102 227.726 69.7976H227.741L228.478 70.2251V73.8802C228.478 73.8802 227.918 79.9818 228.743 83.3274H228.802L229.554 83.7548C229.554 83.7548 238.353 97.2256 238.353 107.867C238.353 118.508 233.754 125.567 233.754 125.567C233.754 125.567 232.678 128.073 231.647 129.532C231.219 130.136 230.733 130.107 230.276 130.004C230.232 130.004 228.11 128.633 228.11 128.633C227.52 128.323 227.122 127.439 227.417 126.614C227.417 126.614 230.571 118.581 230.571 107.94C230.571 99.7606 225.103 89.9154 222.568 85.8034L222.023 85.1107C221.831 85.8477 221.359 87.4688 221.124 88.1321L221.654 88.4269C221.654 88.4269 212.001 111.875 212.001 122.517C212.001 133.158 215.612 136.621 215.612 136.621C216.127 137.446 214.55 140.851 213.519 140.586C213.386 140.556 213.253 140.497 213.121 140.438L210.306 138.743C209.421 138.316 208.611 137.358 208.611 137.358C208.611 137.358 205 133.895 205 123.253C205 112.612 213.401 88.5153 213.401 88.5153"
      fill="white"
    />
    <path
      d="M221.638 88.4414L218.189 90.4605C217.983 90.5785 217.718 90.6374 217.453 90.6374C217.187 90.6374 216.922 90.5785 216.716 90.4605L213.385 88.5298"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M219.001 69.3553L214.078 66.4961"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M229.553 83.7695L226.148 85.8328C225.942 85.9507 225.676 86.0097 225.411 86.0097C225.146 86.0097 224.881 85.9507 224.674 85.8328L222.36 84.4769"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M213.104 140.439C212.205 140.012 211.394 139.054 211.394 139.054C211.394 139.054 207.798 135.59 207.798 124.949C207.798 115.045 216.154 94.0428 217.319 91.1836"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M218.146 76.195L214.078 73.8516"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M219.002 69.3555C218.604 70.4314 218.368 71.5367 218.368 72.5832C218.368 73.379 218.501 74.057 218.751 74.6171"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M225.604 86.5711C227.019 88.8408 234.167 100.705 234.167 110.3C234.167 120.941 229.568 128 229.568 128C229.229 128.767 229.686 129.725 230.276 130.02M223.305 75.5469C223.305 75.5469 223.88 83.196 225.663 85.8489"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M221.932 36.5781L223.303 56.0032M224.231 63.4902V55.4726L222.374 56.5485V64.5661"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M222.597 36.1934L221.271 36.9597L218.146 62.3244V68.8387L218.987 69.3545"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M218.898 74.9121L218.146 76.1943V79.8494C218.146 79.8494 218.794 86.1132 217.674 90.5199"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M218.898 74.913L214.845 72.5696M218.146 62.3265L214.093 59.9831M219.959 36.166L221.271 36.9619"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M213.401 88.515C213.401 88.515 205 112.612 205 123.253C205 133.894 208.611 137.358 208.611 137.358C208.611 137.358 209.421 138.316 210.306 138.743L213.121 140.438C213.253 140.497 213.386 140.556 213.519 140.585C214.55 140.851 216.113 137.461 215.597 136.621C215.597 136.621 211.986 133.157 211.986 122.516C211.986 111.875 221.639 88.4265 221.639 88.4265L221.109 88.117C222.701 83.9461 223.187 77.2696 223.275 75.8105M228.802 83.3124L229.554 83.7545C229.554 83.7545 238.353 97.2106 238.353 107.866C238.353 118.522 233.754 125.567 233.754 125.567C233.754 125.567 232.678 128.073 231.647 129.532C231.219 130.136 230.733 130.106 230.276 130.003C230.232 130.003 228.11 128.633 228.11 128.633C227.52 128.323 227.107 127.439 227.417 126.613C227.417 126.613 230.571 118.581 230.571 107.94C230.571 99.2444 224.396 88.6771 222.126 85.0957"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M220.622 35.7812L221.934 36.5771"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M218.751 74.6016C219.503 76.267 221.257 76.7239 223.306 75.5301C225.236 74.4247 226.902 72.155 227.712 69.7969"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M224.234 63.4746C223.939 63.5778 223.629 63.7251 223.305 63.902C221.463 64.9631 219.842 67.0855 219.001 69.3404"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M228.933 83.9915C227.828 80.8817 228.462 73.8958 228.462 73.8958V70.2406L227.725 69.828H227.71C228.049 68.8258 228.241 67.8236 228.241 66.8803C228.241 65.8487 228.019 65.0233 227.621 64.4043L228.462 62.8863V56.3719L222.581 36.2099L221.269 35.4141L220.606 35.7973L219.943 36.1804L214.062 59.9975V66.5119L214.917 67.0277C214.504 68.1036 214.283 69.209 214.283 70.2554C214.283 71.2134 214.475 71.9945 214.829 72.5841L214.062 73.8663V77.5214C214.062 77.5214 214.726 83.9915 213.532 88.3982"
      stroke="#6B7073"
      strokeWidth={2}
      strokeMiterlimit={10}
    />
    <path
      d="M300.142 36.4573C304.298 34.055 307.703 35.4994 307.703 39.6556V117.297C307.703 121.512 305.801 122.603 303.502 123.929L276.502 139.508C272.346 141.91 269 140.466 269 136.309V58.609C269 54.3496 270.901 53.3032 273.2 51.9768L300.201 36.3984"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path
      d="M300.142 36.4573C304.298 34.055 307.703 35.4994 307.703 39.6556V117.297C307.703 121.512 305.816 122.603 303.502 123.929L276.502 139.508C272.346 141.91 269 140.466 269 136.309V58.609C269 54.3496 270.886 53.3032 273.215 51.9768L300.216 36.3984"
      fill="white"
    />
    <path
      d="M276.498 139.507C274.184 140.849 272.297 140.038 272.297 137.724V60.5102C272.297 56.2508 274.184 55.2044 276.498 53.878L303.498 38.2848C305.812 36.9436 307.699 37.7543 307.699 40.0682"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M272.635 140.657C271.441 140.598 270.646 139.743 270.646 138.24V59.5814C270.646 55.4252 272.547 54.2756 274.861 52.9491L303.173 36.6044C304.794 35.6611 306.209 35.779 306.916 36.7223M281.876 53.9661L276.998 56.7811C275.804 57.4738 274.831 59.1687 274.831 60.5836C274.831 61.9984 275.804 62.5732 276.998 61.8805L281.876 59.0655C283.07 58.3728 284.043 56.6779 284.043 55.2778C284.043 53.8776 283.07 53.2881 281.876 53.9808V53.9661Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M277.798 58.8587C277.798 59.3745 277.444 59.9788 277.017 60.2293C276.59 60.4799 276.236 60.2735 276.236 59.7577C276.236 59.2419 276.59 58.6376 277.017 58.3871C277.444 58.1365 277.798 58.3428 277.798 58.8587ZM279.449 59.124C278.874 59.4482 278.417 59.1829 278.417 58.5049C278.417 57.827 278.874 57.0311 279.449 56.6922C280.024 56.3679 280.48 56.6332 280.48 57.3111C280.48 57.9891 280.024 58.785 279.449 59.124ZM282.662 56.0584C282.662 56.5742 282.308 57.1785 281.881 57.4291C281.453 57.6796 281.099 57.4733 281.099 56.9574C281.099 56.4416 281.453 55.8373 281.881 55.5868C282.308 55.3362 282.662 55.5425 282.662 56.0584Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M300.142 36.4573C304.298 34.055 307.703 35.4994 307.703 39.6556V117.282C307.703 121.497 305.801 122.588 303.502 123.914L276.502 139.493C272.346 141.895 269 140.451 269 136.295V58.5943C269 54.3349 270.901 53.2885 273.2 51.962L300.201 36.3837"
      stroke="#6B7073"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path
      d="M282.054 55.0132L277.544 57.6219C276.615 58.1524 275.878 59.4642 275.878 60.5548C275.878 61.6454 276.63 62.0876 277.544 61.557L282.054 58.9483C282.982 58.4178 283.719 57.106 283.719 56.0154C283.719 54.9248 282.968 54.4826 282.054 55.0132Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M282.378 61.1225L287.959 57.9316V61.2589L293.14 64.1225L298.378 67.0134V72.9316L293.14 70.0407L287.959 67.1498V70.4771L282.378 61.1225Z"
      fill="#00BCD4"
    />
    <path
      d="M282.378 61.1225L287.959 57.9316V61.2589L293.14 64.1225L298.378 67.0134V72.9316L293.14 70.0407L287.959 67.1498V70.4771L282.378 61.1225Z"
      fill="#00BCD4"
      stroke="white"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M269.897 72.7276V76.309C269.897 76.7806 270.236 77.3407 270.634 77.5765C271.032 77.8123 271.371 77.6354 271.371 77.1638V73.5824C271.371 73.1108 271.032 72.5508 270.634 72.3149C270.222 72.0791 269.897 72.2559 269.897 72.7276Z"
      fill="white"
    />
    <path
      d="M269.897 72.7276V76.309C269.897 76.7806 270.236 77.3407 270.634 77.5765C271.032 77.8123 271.371 77.6354 271.371 77.1638V73.5824C271.371 73.1108 271.032 72.5508 270.634 72.3149C270.222 72.0791 269.897 72.2559 269.897 72.7276Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
    <path
      d="M269.869 81.0994C269.869 81.6153 270.222 82.2195 270.65 82.4701C271.077 82.7206 271.431 82.5144 271.431 81.9985C271.431 81.4827 271.077 80.8783 270.65 80.6278C270.222 80.3772 269.869 80.5836 269.869 81.0994Z"
      fill="white"
    />
    <path
      d="M269.869 81.0994C269.869 81.6153 270.222 82.2195 270.65 82.4701C271.077 82.7206 271.431 82.5144 271.431 81.9985C271.431 81.4827 271.077 80.8783 270.65 80.6278C270.222 80.3772 269.869 80.5836 269.869 81.0994Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M269.869 85.992C269.869 86.5078 270.222 87.1121 270.65 87.3627C271.077 87.6132 271.431 87.4069 271.431 86.891C271.431 86.3752 271.077 85.7709 270.65 85.5204C270.222 85.2698 269.869 85.4762 269.869 85.992Z"
      fill="white"
    />
    <path
      d="M269.869 85.992C269.869 86.5078 270.222 87.1121 270.65 87.3627C271.077 87.6132 271.431 87.4069 271.431 86.891C271.431 86.3752 271.077 85.7709 270.65 85.5204C270.222 85.2698 269.869 85.4762 269.869 85.992Z"
      stroke="#6B7073"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <rect
      x={27}
      y={124}
      width={17.2584}
      height={17.2584}
      rx={8.62918}
      fill="#01B5DE"
    />
    <path
      d="M35.5983 129.969C35.4383 130.109 35.2583 130.206 35.0583 130.259C34.865 130.306 34.5983 130.329 34.2583 130.329V129.529H34.4183C34.7783 129.529 35.055 129.459 35.2483 129.319C35.4417 129.172 35.5583 128.942 35.5983 128.629H36.5583V135.629H35.5983V129.969Z"
      fill="white"
    />
    <rect
      x={73}
      y={124}
      width={17.2584}
      height={17.2584}
      rx={8.62918}
      fill="#01B5DE"
    />
    <path
      d="M79.1634 135.629V134.809L82.0534 132.209C82.3468 131.942 82.5668 131.692 82.7134 131.459C82.8601 131.219 82.9334 130.936 82.9334 130.609C82.9334 130.236 82.8101 129.942 82.5634 129.729C82.3234 129.516 82.0168 129.409 81.6434 129.409C81.2101 129.409 80.8568 129.532 80.5834 129.779C80.3168 130.026 80.1734 130.366 80.1534 130.799H79.2334C79.2534 130.366 79.3701 129.976 79.5834 129.629C79.7968 129.282 80.0801 129.012 80.4334 128.819C80.7868 128.626 81.1868 128.529 81.6334 128.529C82.0534 128.529 82.4301 128.612 82.7634 128.779C83.1034 128.946 83.3701 129.182 83.5634 129.489C83.7568 129.796 83.8534 130.152 83.8534 130.559C83.8534 130.992 83.7534 131.382 83.5534 131.729C83.3601 132.069 83.0701 132.409 82.6834 132.749L80.4134 134.749H83.9934V135.629H79.1634Z"
      fill="white"
    />
    <rect
      x={157}
      y={124}
      width={17.2584}
      height={17.2584}
      rx={8.62918}
      fill="#01B5DE"
    />
    <path
      d="M165.601 135.729C165.081 135.729 164.627 135.616 164.241 135.389C163.861 135.162 163.564 134.862 163.351 134.489C163.137 134.109 163.017 133.692 162.991 133.239H163.891C163.924 133.719 164.087 134.109 164.381 134.409C164.681 134.702 165.081 134.849 165.581 134.849C166.061 134.849 166.437 134.706 166.711 134.419C166.991 134.126 167.131 133.722 167.131 133.209C167.131 132.709 166.964 132.326 166.631 132.059C166.297 131.786 165.887 131.649 165.401 131.649H165.181V130.779L166.581 129.509H163.301V128.629H167.781V129.539L166.191 130.909C166.737 131.042 167.194 131.299 167.561 131.679C167.927 132.052 168.111 132.562 168.111 133.209C168.111 133.676 168.001 134.102 167.781 134.489C167.561 134.876 167.257 135.179 166.871 135.399C166.491 135.619 166.067 135.729 165.601 135.729Z"
      fill="white"
    />
    <rect
      x={238}
      y={124}
      width={17.2584}
      height={17.2584}
      rx={8.62918}
      fill="#01B5DE"
    />
    <path
      d="M248.319 135.629H247.359V134.089H244.099V133.209L247.419 128.629H248.319V133.209H249.159V134.089H248.319V135.629ZM247.359 130.139L245.119 133.209H247.359V130.139Z"
      fill="white"
    />
    <rect
      x={306}
      y={124}
      width={17.2584}
      height={17.2584}
      rx={8.62918}
      fill="#01B5DE"
    />
    <path
      d="M314.546 135.729C314.086 135.729 313.67 135.632 313.296 135.439C312.923 135.246 312.623 134.976 312.396 134.629C312.176 134.282 312.053 133.886 312.026 133.439H312.986C313.033 133.832 313.19 134.166 313.456 134.439C313.723 134.712 314.086 134.849 314.546 134.849C315.04 134.849 315.43 134.699 315.716 134.399C316.01 134.099 316.156 133.682 316.156 133.149C316.156 132.622 316.01 132.216 315.716 131.929C315.43 131.636 315.066 131.489 314.626 131.489C314.233 131.489 313.903 131.546 313.636 131.659C313.376 131.766 313.133 131.899 312.906 132.059L312.216 131.729L312.656 128.629H316.596V129.509H313.386L313.096 131.179C313.31 131.032 313.563 130.912 313.856 130.819C314.15 130.726 314.45 130.679 314.756 130.679C315.483 130.679 316.06 130.899 316.486 131.339C316.92 131.772 317.136 132.366 317.136 133.119C317.136 133.586 317.033 134.019 316.826 134.419C316.62 134.812 316.32 135.129 315.926 135.369C315.533 135.609 315.073 135.729 314.546 135.729Z"
      fill="white"
    />
  </svg>
)

export default IgToolsNeeded
